import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../../constants";
import { useLandingHeadingDocumentDetails } from "./ServicesList.hooks";

export const EditServicesListPageHeading = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const {
    data: editPageHeading,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useLandingHeadingDocumentDetails(query.get("editId") || "");

  const {
    data: editPageHeadingById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    const activeTab = query.get("activeTab");
    const subActiveTab = query.get("subActiveTab");
    const thirdSubActiveTab = query.get("thirdSubActiveTab");
    if (
      activeTab === "services" &&
      subActiveTab === "servicesList" &&
      thirdSubActiveTab === "servicesListPageHeading"
    ) {
      refetchCategories();
    }
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [
    query.get("activeTab"),
    query.get("subActiveTab"),
    query.get("thirdSubActiveTab"),
    query.get("editId"),
    query.get("id"),
  ]);

  const [currentAirport] = useLocalStorage("currentAirport", null);

  const formConfig: FormConfig = {
    initialValues: {
      title: editPageHeadingById
        ? decodeHTML(editPageHeadingById.payload?.title)
        : editPageHeading
          ? decodeHTML(editPageHeading?.title)
          : "",

      field_page_banner_image: editPageHeadingById
        ? editPageHeadingById.payload?.field_page_banner_image
          ? [
              {
                uid: "-1",
                name: "banner.jpg",
                status: "done",
                url: editPageHeadingById.payload.field_page_banner_image,
              },
            ]
          : []
        : editPageHeading?.field_page_banner_image
          ? [
              {
                uid: "-1",
                name: "banner.jpg",
                status: "done",
                url: editPageHeading.field_page_banner_image,
              },
            ]
          : [],

      field_page_title_en: editPageHeadingById
        ? decodeHTML(editPageHeadingById.payload?.field_page_title_en)
        : editPageHeading
          ? decodeHTML(editPageHeading?.field_page_title_en)
          : "",

      field_page_title_ms: editPageHeadingById
        ? decodeHTML(editPageHeadingById.payload?.field_page_title_ms)
        : editPageHeading
          ? decodeHTML(editPageHeading?.field_page_title_ms)
          : "",

      field_page_title_zh: editPageHeadingById
        ? decodeHTML(editPageHeadingById.payload?.field_page_title_zh)
        : editPageHeading
          ? decodeHTML(editPageHeading?.field_page_title_zh)
          : "",

      field_page_description_en: editPageHeadingById
        ? decodeHTML(editPageHeadingById.payload?.field_page_description_en)
        : editPageHeading
          ? decodeHTML(editPageHeading?.field_page_description_en)
          : "",

      field_page_description_ms: editPageHeadingById
        ? decodeHTML(editPageHeadingById.payload?.field_page_description_ms)
        : editPageHeading
          ? decodeHTML(editPageHeading?.field_page_description_ms)
          : "",

      field_page_description_zh: editPageHeadingById
        ? decodeHTML(editPageHeadingById.payload?.field_page_description_zh)
        : editPageHeading
          ? decodeHTML(editPageHeading?.field_page_description_zh)
          : "",
    },

    fields: fields.servicesListPageHeading,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);

    let imageKeys: any = ["field_page_banner_image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "PASSENGER");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action,
      method,
      module: "Shop & Dine",
      subModule: "services_servicesList_servicesListPageHeading",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: editPageHeading?.id || editPageHeadingById?.payload?.id,
          field_page_header_airport: currentAirport,
          field_page_header_name: data.field_page_header_name,
        }),
        ...data,
      },
      status,
    };

    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${passengerHost}/api/page-headers-crud-data/${editPageHeading?.id || editPageHeadingById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Shop & Dine"
      />
    </>
  );
};
